import { render, staticRenderFns } from "./SituacionBtn.vue?vue&type=template&id=c3e9ed22&"
import script from "./SituacionBtn.vue?vue&type=script&lang=js&"
export * from "./SituacionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports